import { PathOptions } from "leaflet";
import "./ferrovias.css";

const normalize = (s: string) =>
  s.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036F]/g, "");

export const ferrovias = (feature: any): PathOptions => {
  const tipSituac = normalize(feature?.properties?.tip_situac ?? "");

  if (tipSituac === "em operacao") {
    return {
      color: "#4B0082",
      weight: 2,
      opacity: 1,
    };
  }

  if (tipSituac.startsWith("desativ")) {
    // Continuous faded line with X marks along the path
    return {
      color: "#4B0082",
      weight: 2,
      opacity: 0.7,
      className: "ferrovia-desativada",
    };
  }

  // "Em obra", "Planejada" or unknown situação — dashed line
  return {
    color: "#4B0082",
    weight: 2,
    opacity: 1,
    dashArray: "10 6",
  };
};
